import { render, staticRenderFns } from "./UpdateApplyList.vue?vue&type=template&id=87a7bade&"
import script from "./UpdateApplyList.vue?vue&type=script&lang=js&"
export * from "./UpdateApplyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports